import ApparelBom from "../Specification/Model/ApparelBom";
import Copy from "csi/table/Copy";
import declare from "dojo/_base/declare";

const CopySourceBomController = declare(Copy, {
	onCreatePopup(view) {
		const currentNode = this.m_cache.get(this.m_urlNode);
		const isSourceBOM = ApparelBom.isSourceBOM(currentNode);
		const { Subtype } = currentNode;

		if (isSourceBOM && !!Subtype) {
			view.addFixedValue("Subtype", Subtype);
		}
		this.inherited(arguments);
	},
});

export = CopySourceBomController;